<mat-toolbar class="dialog-toolbar">
	<mat-icon fontSet="mdi" [fontIcon]="'mdi-pencil'"></mat-icon>
	<h3 style="padding-left: 6px">{{ 'BOX' | translate }}</h3>
	<span class="fx-grow-1"></span>
	<button mat-icon-button mat-dialog-close tabindex="-1">
		<mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
	</button>
</mat-toolbar>

<mat-dialog-content>
	<form [formGroup]="form" class="fx-layout-column">
		<mat-form-field class="fx-fill-width">
			<mat-label>{{ 'NAME' | translate }}</mat-label>
			<input
				matInput
				placeholder="{{ 'NAME' | translate }}"
				formControlName="name"
				required />
		</mat-form-field>

		<mat-form-field class="fx-fill-width">
			<mat-label>{{ 'DESCRIPTION' | translate }}</mat-label>
			<textarea
				matInput
				placeholder="{{ 'DESCRIPTION' | translate }}"
				formControlName="description"></textarea>
		</mat-form-field>
	</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button color="warn" [mat-dialog-close]="null">
		{{ 'CANCEL' | translate }}
	</button>
	<button
		mat-button
		color="primary"
		(click)="saveData(form.value)"
		[disabled]="form.invalid">
		{{ 'SAVE' | translate }}
	</button>
</mat-dialog-actions>
